import React from 'react';
import 'react-photo-view/dist/react-photo-view.css';
import './index.less';

interface Props {
  item: { labelName: string; labelCode: string }
}
export default (props: Props) => {
  const { item } = props
  const newXp = 'newXpSelfOperate'
  const xp = 'xpSelfOperate'
  const partnership = 'preferredPartnership'

  return (
    <div>
      {partnership === item.labelCode ?
        <div className='partnership'>
          <div className='head'>优</div>
          <div className='text'>{item.labelName}</div>
        </div>
        : xp === item.labelCode ?
          <div className='xpTag'>
            <div className="headWrap">
              <div className='head'></div>
            </div>
            <div className='text'>{item.labelName}</div>
          </div>
          : newXp === item.labelCode ?
            <div className='newXpTag'>
              <div className='head'>新</div>
              <div className='text'>{item.labelName}</div>
            </div>
            : <div className={`tag ${item.labelCode}`}>
              {item.labelName}
            </div>
      }
    </div>
  );
};
